module.exports = __webpack_public_path__ + "img/deskshelf13.b676851f.jpg";